// import homepage from '../../assets/images/homepage.jpg'
import './home.scss'

function Home() {
    return (
        <div className='home'>
            {/* <img
                className='landingImg'
                src={homepage}
                alt='Landing page background'
            /> */}
        </div>
    )
}
export default Home
